module.exports = __webpack_public_path__ + "img/7.39750ee6.svg";